import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AWBDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/awb-delete.component';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AWBService } from 'src/app/services/operations/awb.service';

@Component({
  selector: 'app-awb-additional-tat',
  templateUrl: './awb-additional-tat.component.html',
  styleUrls: ['./awb-additional-tat.component.scss']
})
export class AwbAdditionalTatComponent {
  tatForm: FormGroup;
  @Input() public cellData: any;
  isFormSubmitted = false;
  awbNumber: string;
  selectedSCId: number;
  AWBTATList = [];

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;

  defaultColDef = {
    sortable: true,
    resizable: false,
    filter: true
  };

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight'
  }

  columnDefs = [
    //{ headerName: 'Description', field: 'chargesid' },
    { headerName: 'Transit Time', field: 'tat', minWidth: 150 },
    { headerName: 'Remark', field: 'remark', minWidth: 250 },
    {
      headerName: 'Actions',
      field: 'id',
      cellRendererParams: { context: this },
      cellRenderer: AWBDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 50,
      filter: false
    },
  ];

  constructor(
    private _fb: FormBuilder,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private awbService: AWBService,
    public activeModal: NgbActiveModal,
    private titleService: Title
  ) { 
    titleService.setTitle('Air Way Bill');
    this.context = { componentParent: this } 
  }

  ngOnInit() {
    this.tatForm = this._fb.group({
      txtDays: [null],
      txtHours: [null],
      txtMinutes: [null],
      txtRemark: [null, Validators.required]
    });
    if (this.cellData) {
      // this.getAllStatuses();
      this.awbNumber = this.cellData.awbnumber;
      this.getTATList();
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
      });
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  getTATList() {
    if (this.awbNumber) {
      try {
        this.AWBTATList = [];
        this.awbService.GetTATByAwbnumber(this.awbNumber).subscribe(res => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            // console.log(res);
            res.data.map(x => {
              this.AWBTATList.push({
                id: x.id,
                remark: x.remark,
                tat: `${x.tat?.days || 0}d ${x.tat?.hours || 0}h ${x.tat?.minutes || 0}m`
              });
            });

            //console.log('AWBTATList', this.AWBTATList);
            this.AWBTATList = [...this.AWBTATList];
          } else if (res && !res.sucess) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
        })
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    }
  }

  onSaveClick() {
    if (this.tatForm.valid) {
      const requestObj = {
        generatedfromid: this.selectedSCId,
        awbnumber: this.awbNumber,
        remark: this.tatForm.get('txtRemark').value,
        tat: {
          days: this.tatForm.get('txtDays').value,
          hours: this.tatForm.get('txtHours').value,
          minutes: this.tatForm.get('txtMinutes').value
        }
      }
      // console.log('requestObj', requestObj);
      this.ngxLoaderService.start();
      try {
        this.awbService.AddTAT(requestObj).subscribe(res => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            this.getTATList();
            // console.log(res);
            this.appCoreService.showMessage('TAT added successsfully', 'Success', 'success');
            this.resetFrom();
            //this.activeModal.close();
          } else if (res && !res.sucess) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
        })
      } catch (error) {
        this.ngxLoaderService.stop();
      }
    }
  }

  deleteAction(cell) {
    try {
      if (cell && cell.id) {
        this.awbService.DeleteTATById(cell.id).subscribe(res => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            this.getTATList();
          } else if (res && !res.sucess) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
        })
      }
    } catch (error) {
      this.ngxLoaderService.stop();
    }
  }

  resetFrom() {
    this.isFormSubmitted = false;
    this.tatForm.reset();
  }
}
